import { Injectable } from '@angular/core';
import { FormExtractorService } from '../../../../shared/services/form-extractor.service';
import { FNSimple } from '../models/FNSimple';
import { OrganismeService } from './organisme/organisme.service';

@Injectable({
  providedIn: 'root'
})
export class FnsimpleService {

  constructor(public organismeService: OrganismeService, private formExtractorService: FormExtractorService) { }

    getFnSimple(controls){
      const fNSimple = new FNSimple();
      fNSimple.annulationFromFNSimple = null;
      fNSimple.attribution = null;
      fNSimple.initialFromFNSimple = null;
      fNSimple.rectificatifFromFNSimple = null;
          
      fNSimple.organisme = this.organismeService.getOrganisme(controls);
  
      return fNSimple;
    }
}
